<template>
    <client-page class="wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'매칭상담회'"></sub-visual>
        
        <div class="contents">
            <section class="section">
                <div class="ct">
                    <!-- 상담회 뷰 -->
                    <fair-view v-slot:default="{fair}" @apply="apply">
                        <div class="tab-menu">
                            <div class="swiper-container">
                                <div class="swiper-wrapper">
                                    <tab-item
                                        v-for="item in list"
                                        v-bind="item" :key="item.id"
                                        v-model="currentId"/>
                                </div>  
                            </div>
                        </div>
                        <div v-if="fair" class="tab-contents">
                            <transition>
                                <section class="item" :key="currentId">
                                    <!-- 매칭상담회 설명 -->
                                    <fair-view-intro v-if="currentId == 1" :fair="fair"></fair-view-intro>
                                    
                                    <!-- 참여제품: 리스트 -->
                                    <product-list v-if="currentId == 2 && !product" :fair="fair" v-slot:default="{products}" show-category show-award show-keyword show-pagination>
                                        <product-list-item v-for="product in products" :key="product._id" :product="product" @click="product => $data.product = product" :disabled="!scope.includes('buyer')"></product-list-item>
                                    </product-list>

                                    <!-- 참여제품: 뷰 -->
                                    <fair-product-view v-if="currentId == 2 && product" :fair="fair" :product="product" show-back @back="product = null"></fair-product-view>

                                    <!-- 참여기업 -->
                                    <application-seller v-if="currentId == 3" :_fair="fair._id"></application-seller>
                                    <!-- 참여바이어 -->

                                    <application-buyer v-if="currentId == 4" :_fair="fair._id"></application-buyer>
                                </section>
                            </transition>
                        </div>
                    </fair-view>
                    
                    <fair-modal ref="fair-modal"></fair-modal>
                </div>
            </section>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import FairView from "@/components/client/fair/fair-view.vue";
import FairModal from "@/components/client/fair/fair-modal.vue";

import TabItem from "@/components/client/tab/tab-item.vue";

import ProductList from '@/components/client/fair/product-list.vue';
import ProductListItem from '@/components/client/fair/product-list-item.vue';
import FairViewIntro from '@/components/client/fair/fair-view-intro.vue';
import FairProductView from '@/components/client/fair/fair-product-view.vue';
import ApplicationBuyer from "@/components/client/fair/application-buyer.vue";
import ApplicationSeller from "@/components/client/fair/application-seller.vue";
import TableItem from '@/components/client/table/table-item.vue';

export default {
    components: {
        ClientPage,
        SubVisual,
        FairView,
        FairModal,
        
        TabItem,
        ProductList,
        ProductListItem,
        FairViewIntro,
        FairProductView,
        ApplicationBuyer,
        ApplicationSeller,
        TableItem,
    },
    data(){
        return{
            currentId: 1,

            product: null,
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init: function(){
            setTimeout(function(){
                var tabMenu = new Swiper ('.tab-menu .swiper-container', {
                    allowTouchMove: false,
                    slidesPerView: 'auto',
                    freemode: true,
                    breakpoints: {
                        768: {
                            allowTouchMove: true,
                        }
                    }
                });
            }, 100);
        },
        apply(fair){
            this.$refs["fair-modal"].fair = fair;
            this.$refs["fair-modal"].open();
        }
    },
    computed: {
        payload(){
            return this.$store.state.payload || {};
        },
        scope(){
            return this.payload?.scope || [];
        },
        list(){
            return this.scope.includes("buyer") || this.scope.includes("seller")
            ? [ { id: 1, label: '매칭상담회 설명', content: '1' },
                { id: 2, label: '참여제품', content: '2' },
                { id: 3, label: '참여기업', content: '3' },
                { id: 4, label: '참여바이어', content: '4' } ]
            : [ { id: 1, label: '매칭상담회 설명', content: '1' } ]
        }
    }
};
</script>
<style lang="scss" scoped>

</style>